// extracted by mini-css-extract-plugin
module.exports = {"root":"UiContainer_root_2SmAf","isFluid":"UiContainer_isFluid_3_b8a"};